export const archiveSelection = [
    'CREDIT_CHECK_FAILED',
    'TOO_EXPENSIVE',
    'CHANGED_MIND',
    'DUPLICATE_ENTRY',
    'WANT_NHS',
    'CLINICALLY_NOT_SUITABLE',
    'PRACTICE_TOO_FAR',
    'ANOTHER_PRACTICE',
    'NO_RESPONSE'
];

export const followUpSelection = [
    'FOLLOW_UP',
    'UNABLE_TO_CONTACT',
    'AWAITING_RESPONSE'
];

// Note types that register a CONTACT ATTEMPT.
//
// A LeadNote only counts as a contact attempt when BOTH `contacted_via` is set
// AND its `note` type is one of `followUpSelection` above, or NHS_WAITING_LIST.
// The backend applies that pair in four separate places: the contacted-count
// receiver that moves a lead out of the New sub-tab, the `last_contacted_at`
// annotation behind the Last Contact column, the stuck-lead Sentry check, and
// the backfill commands.
//
// `note` is optional on the notes API and the serializer coerces a missing
// value to OTHER, which is on none of those lists. So omitting it does not mean
// "unspecified" — it means the attempt is invisible to every one of them. Any
// screen that POSTs a note with `contacted_via` must therefore send a type too.
//
// Reaching someone is a follow-up; missing them is an unsuccessful attempt.
export const CONTACT_MADE_NOTE = 'FOLLOW_UP';
export const CONTACT_ATTEMPTED_NOTE = 'UNABLE_TO_CONTACT';

export const VISIBLE_CONTACT_METHODS = ['PHONE', 'EMAIL', 'ONLINE', 'WHATSAPP'];

export const PRIMARY_ARCHIVE_REASONS = [
    'TOO_EXPENSIVE',
    'CHANGED_MIND',
    'ANOTHER_PRACTICE',
    'WANT_NHS',
    'CLINICALLY_NOT_SUITABLE',
];